import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import { getFinancialYearLabels } from "../../brsrFinancialYearLabels";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  HEADER_FILL,
  HEADER_ROW,
  TABLE_HEADER_FILL,
  TITLE_ROW,
} from "./principle1DetailHelpers";

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

export const SHEET_NAME = "Details of other waste";

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: options.vertical || "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function formatNumber(value) {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (!Number.isNaN(num)) return num.toFixed(2);
  return String(value);
}

export function buildDetailsOfOtherWasteSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  const fy = getFinancialYearLabels(reportingYear);
  const fyCurrent = fy.currentYear ? `FY (${fy.currentYear})` : "FY (Current Financial Year)";
  const fyPrevious = fy.previousYear ? `PY (${fy.previousYear})` : "PY (Previous Financial Year)";

  const widths = { A: 2, B: 2, C: 2, D: 8, E: 18, F: 12, G: 12, H: 14, I: 12, J: 12, K: 14 };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_2, { mergeEnd: COL_K });

  ws.mergeCells(TITLE_ROW, COL_D, TITLE_ROW, COL_K);
  setCell(ws, TITLE_ROW, COL_D, "Details of other waste", {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Name Of Other Waste", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  ws.mergeCells(HEADER_ROW, COL_F, HEADER_ROW, COL_H);
  setCell(ws, HEADER_ROW, COL_F, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  ws.mergeCells(HEADER_ROW, COL_I, HEADER_ROW, COL_K);
  setCell(ws, HEADER_ROW, COL_I, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  const subHeaderRow = HEADER_ROW + 1;
  setCell(ws, subHeaderRow, COL_D, "", { fill: TABLE_HEADER_FILL });
  setCell(ws, subHeaderRow, COL_E, "", { fill: TABLE_HEADER_FILL });
  setCell(ws, subHeaderRow, COL_F, "Re-Used", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_G, "Recycled", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_H, "Safely Disposed", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_I, "Re-Used", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_J, "Recycled", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_K, "Safely Disposed", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  const packaging = sectionC?.principle2?.leadershipIndicator?.reclaimedProductsAndPackaging || {};
  const current = packaging?.currentFinancialYear?.otherWaste || {};
  const previous = packaging?.previousFinancialYear?.otherWaste || {};
  const row = subHeaderRow + 1;

  setCell(ws, row, COL_D, "1", { align: "center" });
  setCell(ws, row, COL_E, "Other waste", { align: "left" });
  setCell(ws, row, COL_F, formatNumber(current?.reUsed), { align: "center" });
  setCell(ws, row, COL_G, formatNumber(current?.recycled), { align: "center" });
  setCell(ws, row, COL_H, formatNumber(current?.safelyDisposed), { align: "center" });
  setCell(ws, row, COL_I, formatNumber(previous?.reUsed), { align: "center" });
  setCell(ws, row, COL_J, formatNumber(previous?.recycled), { align: "center" });
  setCell(ws, row, COL_K, formatNumber(previous?.safelyDisposed), { align: "center" });

  return ws;
}
